import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
import { Sunrise } from "lucide-react";
import { Card, SectionLabel } from "@/components/ui/Card";
import type { LatestCoachCheck } from "@/types";

function previewText(s: string | null | undefined, maxLen = 220): string {
  if (!s) return "";
  const cleaned = s
    .replace(/^#+\s+/gm, "")
    .replace(/\*\*/g, "")
    .replace(/`/g, "")
    .replace(/\n{2,}/g, "\n")
    .replace(/\n/g, " · ")
    .trim();
  return cleaned.length > maxLen
    ? cleaned.slice(0, maxLen).trimEnd() + "…"
    : cleaned;
}

export function DailyCheckCard({ check }: { check: LatestCoachCheck | null }) {
  const { t } = useTranslation();
  if (!check) {
    return (
      <Card>
        <SectionLabel>{t("dailycheck.title")}</SectionLabel>
        <div className="mt-2 flex items-center gap-2 text-[12px] text-taupe">
          <Sunrise className="h-4 w-4" strokeWidth={1.6} />
          {t("dailycheck.empty")}
        </div>
      </Card>
    );
  }
  const date = new Date(check.created_at);
  return (
    <Link
      to={`/reviews?open=${check.id}`}
      className="block transition-opacity hover:opacity-95"
    >
      <Card>
        <div className="flex items-center justify-between">
          <SectionLabel>{t("dailycheck.title")}</SectionLabel>
          <span className="text-[10px] text-taupe">
            {date.toLocaleDateString(i18n.language || "en", {
              day: "numeric",
              month: "short",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        </div>
        <p className="mt-3 line-clamp-4 text-[14px] leading-relaxed text-navy-deep">
          {previewText(check.narrative_preview)}
        </p>
        <div className="mt-3 text-right text-[11px] text-amber-dark">
          {t("dailycheck.read_full")}
        </div>
      </Card>
    </Link>
  );
}
